import { render, staticRenderFns } from "./BaseNotice.vue?vue&type=template&id=af635846&scoped=true&"
import script from "./BaseNotice.vue?vue&type=script&lang=ts&"
export * from "./BaseNotice.vue?vue&type=script&lang=ts&"
import style0 from "./BaseNotice.vue?vue&type=style&index=0&id=af635846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af635846",
  null
  
)

export default component.exports